import script from "./CreateTreePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateTreePage.vue?vue&type=script&lang=ts&setup=true"

import "./CreateTreePage.vue?vue&type=style&index=0&id=3443f450&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3443f450"]])

export default __exports__